import styled from 'styled-components'
import { Icon } from 'common-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const DropdownListWrapper = styled.div`
  padding: 8px;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: scroll;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.fillSubtle};
  font-size: 10px;
  font-weight: 500;
  line-height: 100%;
  color: ${COLORS.secondarySemiDark};
  white-space: nowrap;
`
